$(document).ready(function () {
  ("use strict");

  // Menú: afegim botó i ocultem menú quan hi ha js
  $("#menu")
    .before(
      '<button class="hamburger hamburger--slider" type="button" aria-expanded="false" aria-controls="menu"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="is-sr-only">Menu</span></button>'
    )
    .attr("hidden", "true");

  // ----
  // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // ----
  var toggleMenu = document.querySelector(".navigation button");
  var menu = document.querySelector("#menu");

  toggleMenu.addEventListener("click", function () {
    var open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
    toggleMenu.setAttribute("aria-expanded", !open);
    menu.hidden = !menu.hidden;
  });

  $(".hamburger").on("click", function () {
    // afegir classe al botó
    $(this).toggleClass("is-active");
    // afegir classe al body
    $("body").toggleClass("js-menu-open");
  });

  // -------------------------------
  // Menú principal amb desplegables (https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle)
  // -------------------------------

  var menuItems = document.querySelectorAll("#menu li.has-submenu");
  Array.prototype.forEach.call(menuItems, function (el, i) {
    var activatingA = el.querySelector("a");
    var btn =
      '<button><span><span class="is-sr-only">Muestra el submenú para “' +
      activatingA.text +
      "”</span></span></button>";
    activatingA.insertAdjacentHTML("afterend", btn);

    el.querySelector("button").addEventListener("click", function (event) {
      var currentMenu = this.parentNode;
      Array.prototype.forEach.call(menuItems, function (el, i) {
        if (currentMenu !== el) {
          el.classList.remove("open");
          el.classList.add("close");
          el.querySelector("button").setAttribute("aria-expanded", "false");
        }
      });
      if (this.parentNode.classList.contains("close")) {
        this.parentNode.classList.add("open");
        this.parentNode.classList.remove("close");
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "true");
      } else {
        this.parentNode.classList.add("close");
        this.parentNode.classList.remove("open");
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "false");
      }
      event.preventDefault();
    });
  });

   // header search (http://adrianroselli.com/2015/12/responsive-progressive-accessible-vanilla-search.html)
    // Get the search field by ID
    var eID = document.getElementById("s1");

    // Declare the event object and set it to null
    var eventObj = null;

    // Add the event listeners I want to track
   // eID.addEventListener("focus", checkSearch, false);
   // eID.addEventListener("blur", checkSearch, false);
   // eID.addEventListener("keydown", checkSearch, false);
	// per ie11
    $("label[for='s1']").on('click', function(e){
    	checkSearch(e);
    	return false;
    });

    function checkSearch(eventObj) {
      try {
        // Get the event type from the object
        var eventType = eventObj.type
        // Map the tab key to a variable
        var TABKEY = 9;
        // Get the search input text value
        var eIDval = eID.value;
        // Get the parent element
        var eIDparent = eID.parentElement;
        // Set a class since we are on it
        eIDparent.className = "notempty";
        // Get the button
        var eIDbutton = eIDparent.getElementsByTagName('button')[0];
        // Set the button tabindex
        eIDbutton.setAttribute('tabindex', '0');
        // If the text value is not blank
        if (eIDval != '') {
          // Give it a class that will stay
          eIDparent.className = "notempty";
        }
        // If the text value is blank
        else {
          // Check if focus has left the input first
          if (eventType == 'blur') {
            // Set tabindex on button to remove from flow
            eIDbutton.setAttribute('tabindex', '-1');
            // Remove the class
            eIDparent.className = "";
          }
          // Check if user hit a key
          if (eventType == 'keydown') {
            // See if the user hit the tab key
            if (eventObj.keyCode == TABKEY) {
              // Set tabindex on button to remove from flow
              eIDbutton.setAttribute('tabindex', '-1');
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // ----------
  // scroll top
  // ----------
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".scrolltop").addClass("visible");
    } else {
      $(".scrolltop").removeClass("visible");
    }
  });

  // ------
  // Slider
  // ------
  $(".slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 2000,
    autoplay: true
  });

  // ------------
  // fixed header
  // ------------
  $(window).scroll(function () {
    var stickyNav = $(".main-nav");
    var scroll = $(window).scrollTop();
    var body = $("body");
    if (scroll >= 95) {
      stickyNav.addClass("fixed");
      var navHeight = stickyNav.outerHeight();
      // body.css("padding-top", navHeight);
      body.addClass("sticky-nav");
    } else {
      stickyNav.removeClass("fixed");
      // body.css("padding-top", "0");
      body.removeClass("sticky-nav");
    }
  });

  // ----
  // Tabs https://inclusive-components.design/tabbed-interfaces/
  // ----
  if ($(".tabbed").length > 0) {
    $(".tabbed").each(function (index, element) {
      // Get relevant elements and collections
      var tabbed = element;
      var tablist = tabbed.querySelector("ul.tab-menu");
      var tabs = tablist.querySelectorAll("a");
      var panels = tabbed.querySelectorAll(".tab-panel");

      // The tab switching function
      var switchTab = function switchTab(oldTab, newTab) {
        newTab.focus(); // Make the active tab focusable by the user (Tab key)

        newTab.removeAttribute("tabindex"); // Set the selected state

        newTab.setAttribute("aria-selected", "true");
        oldTab.removeAttribute("aria-selected");
        oldTab.setAttribute("tabindex", "-1"); // Get the indices of the new and old tabs to find the correct
        // tab panels to show and hide

        var index = Array.prototype.indexOf.call(tabs, newTab);
        var oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
        panels[oldIndex].hidden = true;
        panels[index].hidden = false;
      }; // Add the tablist role to the first <ul> in the .tabbed container

      tablist.setAttribute("role", "tablist"); // Add semantics are remove user focusability for each tab

      Array.prototype.forEach.call(tabs, function (tab, i) {
        tab.setAttribute("role", "tab");
        //	    tab.setAttribute("id", "tab" + (i + 1));
        tab.setAttribute("tabindex", "-1");
        tab.parentNode.setAttribute("role", "presentation"); // Handle clicking of tabs for mouse users

        tab.addEventListener("click", function (e) {
          e.preventDefault();
          var currentTab = tablist.querySelector("[aria-selected]");

          if (e.currentTarget !== currentTab) {
            switchTab(currentTab, e.currentTarget);
          }
        }); // Handle keydown events for keyboard users

        tab.addEventListener("keydown", function (e) {
          // Get the index of the current tab in the tabs node list
          var index = Array.prototype.indexOf.call(tabs, e.currentTarget); // Work out which key the user is pressing and
          // Calculate the new tab's index where appropriate

          var dir =
            e.which === 37
              ? index - 1
              : e.which === 39
              ? index + 1
              : e.which === 40
              ? "down"
              : null;

          if (dir !== null) {
            e.preventDefault(); // If the down key is pressed, move focus to the open panel,
            // otherwise switch to the adjacent tab

            dir === "down"
              ? panels[i].focus()
              : tabs[dir]
              ? switchTab(e.currentTarget, tabs[dir])
              : void 0;
          }
        });
      }); // Add tab panel semantics and hide them all

      Array.prototype.forEach.call(panels, function (panel, i) {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("tabindex", "-1");
        var id = panel.getAttribute("id");
        panel.setAttribute("aria-labelledby", tabs[i].id);
        panel.hidden = true;
      }); // Initially activate the first tab and reveal the first tab panel

      tabs[0].removeAttribute("tabindex");
      tabs[0].setAttribute("aria-selected", "true");
      panels[0].hidden = false;
    });
  }
});

// --------
// Counters
// --------
$(".numbers-list span").each(function () {
  var element = $(this);
  // element.addClass('hidden');
  element.viewportChecker({
    // classToAdd: 'visible',
    callbackFunction: function () {
      var info = element.text().replace(/\./g, "").replace(",", ".").split(".");
      // var info = element.text().replace(/\,/g, '').replace('.', ',').split(",");
      var counter = info[0];
      var sufix = "";
      if (typeof info[1] != "undefined") {
        // sufix = ','+info[1]
        sufix = "." + info[1];
      }
      element.prop("Counter", 0).animate(
        {
          Counter: counter,
          //Counter: 65139
        },
        {
          duration: 2000,
          easing: "swing",
          step: function (now) {
            element.text(Math.ceil(now).toLocaleString("es") + sufix);
            // element.text(Math.ceil(now).toLocaleString('en')+sufix);
          },
        }
      );
    },
  });
});

// -----------
// Collapsible (https://inclusive-components.design/collapsible-sections/)
// -----------
(function () {
  // Get all the headings
  const headings = document.querySelectorAll(".collapsible__title");

  Array.prototype.forEach.call(headings, (heading) => {
    // Give each <h2> a toggle button child
    // with the SVG plus/minus icon
    heading.innerHTML = `
      <button aria-expanded="false" class="is-flex is-justify-content-space-between is-align-items-center py-3 px-4">
        ${heading.textContent}
        <svg aria-hidden="true" focusable="false" viewBox="0 0 24 16">
          <path d="M12.013 15.142.765 2.495V.876h22.484v1.709L12.013 15.142zM2.667 2.375l9.35 10.513 9.407-10.513H2.667z" fill-rule="nonzero"/>
        </svg>
      </button>
    `;
    // Function to create a node list
    // of the content between this heading and the next
    const getContent = (elem) => {
      let elems = [];
      while (
        elem.nextElementSibling &&
        elem.nextElementSibling.className !== "collapsible__title"
      ) {
        elems.push(elem.nextElementSibling);
        elem = elem.nextElementSibling;
      }

      // Delete the old versions of the content nodes
      elems.forEach((node) => {
        node.parentNode.removeChild(node);
      });

      return elems;
    };

    // Assign the contents to be expanded/collapsed (array)
    let contents = getContent(heading);

    // Create a wrapper element for `contents` and hide it
    let wrapper = document.createElement("div");
    wrapper.hidden = true;

    // Add each element of `contents` to `wrapper`
    contents.forEach((node) => {
      wrapper.appendChild(node);
    });

    // Add the wrapped content back into the DOM
    // after the heading
    heading.parentNode.insertBefore(wrapper, heading.nextElementSibling);

    // Assign the button
    let btn = heading.querySelector("button");

    btn.onclick = () => {
      // Cast the state as a boolean
      let expanded = btn.getAttribute("aria-expanded") === "true" || false;

      // Switch the state
      btn.setAttribute("aria-expanded", !expanded);
      // Switch the content's visibility
      wrapper.hidden = expanded;
    };
  });


  // if (!$('#field_76_0').is(':checked') &&
  //     !$('#field_76_1').is(':checked') &&
  //     !$('#field_76_2').is(':checked')) {

  //   $('#field_76_3').prop('checked', true);
  //   $('#field_76_other').show().attr('required', true);
  // }
  // // Inicialización para field_64
  // if (!$('#field_64_0').is(':checked') &&
  //     !$('#field_64_1').is(':checked') &&
  //     !$('#field_64_2').is(':checked')) {

  //   $('#field_64_3').prop('checked', true);
  //   $('#field_64_other').show().attr('required', true);
  // }


  $('input[name="76"]').change(function() {
    if ($('#field_76_3').is(':checked')) {
      $('#field_76_other').show().attr('required', true);
    } else {
      $('#field_76_other').hide().val('').removeAttr('required');
      $('#field_76_other-error').hide();
    }
  });

  $('input[name="64"]').change(function() {
    if ($('#field_64_3').is(':checked')) {
      $('#field_64_other').show().attr('required', true);
    } else {
      $('#field_64_other').hide().val('').removeAttr('required');
      $('#field_64_other-error').hide();
    }
  });

  $('input[name="64"]').change(function() {
    var isChecked = $('input[name="64"]:checked').length > 0;

    if (!isChecked) {
        $('input[name="64"]').attr('required', true);
    } else {
        $('input[name="64"]').removeAttr('required');
    }
  });

  $('input[name="76"]').change(function() {
    var isChecked = $('input[name="76"]:checked').length > 0;

    if (!isChecked) {
        $('input[name="76"]').attr('required', true);
    } else {
        $('input[name="76"]').removeAttr('required');
    }
  });

  $('input[name="64"]').trigger('change');
  $('input[name="76"]').trigger('change');

  if (
    $(".collapsible__title").length > 0 &&
    window.location.hash.indexOf("#entry-") > -1 &&
    $(window.location.hash).length > 0
  ) {
    $(window.location.hash).find("button").attr("aria-expanded", true);
    $(window.location.hash).next().show();
    $("html, body").animate(
      {
        scrollTop: $(window.location.hash).parent().offset().top,
      },
      1000
    );
  }

})();
